import React, { Component } from 'react';
import Translation from '../translation/translation';
import $ from 'jquery';

class SelectAll extends Component {

    constructor(props) {
        super(props);
        this.Click = this.Click.bind(this);


    }

    Click() {
        var check = $("input[id^='" + this.props.cbid + "']")[0].checked;
        $("input[id^='" + this.props.cbid + "']").prop("checked", !check);
    }


    render() {

        return (
            <button type="button" onClick={this.Click} className="btn btn-default">{Translation.Trans("checkuncheckall")}</button>
        )
    }
}

export default SelectAll;


// WEBPACK FOOTER //
// ./src/controls/selectall.js